import { render, staticRenderFns } from "./LostDivReturnDetailPopup.vue?vue&type=template&id=b67b82cc&scoped=true&"
import script from "./LostDivReturnDetailPopup.vue?vue&type=script&lang=js&"
export * from "./LostDivReturnDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./LostDivReturnDetailPopup.vue?vue&type=style&index=0&id=b67b82cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67b82cc",
  null
  
)

export default component.exports